export const defaultRiskMatrix = {
	grades: {
		lofRanges: [2.0, 4.0, 6.0, 8.0, 10.0],
		cofRanges: [2.0, 4.0, 6.0, 8.0, 10.0],
	},
	grid: [
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'negligible',
			position: { x: 0, y: 0 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'negligible',
			position: { x: 0, y: 1 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'low',
			position: { x: 0, y: 2 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 0, y: 3 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 0, y: 4 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'negligible',
			position: { x: 1, y: 0 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'low',
			position: { x: 1, y: 1 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 1, y: 2 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 1, y: 3 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 1, y: 4 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'low',
			position: { x: 2, y: 0 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 2, y: 1 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 2, y: 2 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 2, y: 3 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'high',
			position: { x: 2, y: 4 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 3, y: 0 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 3, y: 1 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 3, y: 2 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'high',
			position: { x: 3, y: 3 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'extreme',
			position: { x: 3, y: 4 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 4, y: 0 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'medium',
			position: { x: 4, y: 1 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'high',
			position: { x: 4, y: 2 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'extreme',
			position: { x: 4, y: 3 },
		},
		{
			pipeCount: 0,
			pipeLength: 0,
			grade: 'extreme',
			position: { x: 4, y: 4 },
		},
	],
};
